import { useContext } from 'react';
import { useApi } from '../api/api.service';
import { StoreContext } from '@/components/providers/store.provider';
import { useMutation } from '@tanstack/react-query';
import { CallbackResponse } from '../auth/auth.types';
import { errorHandler } from '@/lib/utils/error-handler';

export const useAuth = () => {
  const { api } = useApi();
  const { userStore } = useContext(StoreContext);
  const auth = useMutation({
    mutationKey: ['/tma/callback'],
    mutationFn: async (authorization: string) => {
      try {
        const response = await api.get<CallbackResponse>('/tma/callback', {
          headers: { 'x-tma': authorization },
        });
        localStorage.setItem('access-token', response.data.result.token);
        userStore.setIsAuth(true);
        userStore.setUser(response.data.result.user);
        return response.data;
      } catch (error: any) {
        errorHandler(error);
      }
    },
  });
  return { auth };
};
